import { gql } from '@apollo/client'

import { USER_DETAILS_FRAGMENT } from '../fragments'

const USERS_QUERY = gql`
  query users {
    users {
      ...UserDetailsFragment
      roles {
        ...SimpleEntityFragment
      }
    }
  }
  ${USER_DETAILS_FRAGMENT}
`

export default USERS_QUERY
